import { render } from "./PantryPage.vue?vue&type=template&id=10ff23cf&ts=true"
import script from "./PantryPage.vue?vue&type=script&lang=ts"
export * from "./PantryPage.vue?vue&type=script&lang=ts"

import "./PantryPage.vue?vue&type=style&index=0&id=10ff23cf&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__